import { ADD_NEW_CONTACT, UPDATE_CONTACT, DELETE_CONTACT, FETCH_CONTACTS_BY_USER, START_LOADING, END_LOADING } from '../actions/constants'

const contacts = (state = { isLoading: true, contacts: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true }
    case END_LOADING:
      return { ...state, isLoading: false }
    case FETCH_CONTACTS_BY_USER:
      return { ...state, contacts: action.payload }
    case ADD_NEW_CONTACT:
      return { ...state, contacts: [...state.contacts, action.payload] }
    case UPDATE_CONTACT:
      return { ...state, contacts: state.contacts.map((c) => (c._id === action.payload._id ? action.payload : c)) }
    case DELETE_CONTACT:
      return { ...state, contacts: state.contacts.filter((c) => c._id !== action.payload) }
    default:
      return state
  }
}

export default contacts
